import { Flex, Typography, Row, Col, App } from "antd";
import VerifiedIcon from "../../assets/icons/verified-icon.svg";
import EyeIcon from "../../assets/icons/eye.svg";
import EyeSlashIcon from "../../assets/icons/eye-slash.svg";
import { downloadBlob, getDownloadSuccessMessage } from "../../helpers/helpers";
import CustomButton from "../CustomButton/Button";

const { Text } = Typography;

const ProfileDetail = ({
    label,
    value,
    isVerified,
    showValue,
    setShowValue,
    onEdit,
    isMasked,
    isEditable,
    copyable,
    downloadBtn
}) => {
    const { message } = App.useApp();

    const handleSlaDownload = async () => {
        try {
            const response = await fetch(value, { mode: 'cors' });
            const blob = await response.blob();
            const downloadedFileName = value.split('/').pop() || 'file.pdf';
            downloadBlob(blob, downloadedFileName);
            message.success(getDownloadSuccessMessage(downloadedFileName));
        } catch (error) {
            console.error("Failed to download PDF:", error);
            message.error("Failed to download file. Please try again later.");
        }
    };

    return (
        <Row
            gutter={[16, 16]}
            className="custom-profile-row"
            align="middle"
            style={{ marginBottom: 20 }}
        >
            <Col xs={24} lg={6}>
                <Flex gap={8} align="center" wrap>
                    <Text style={{ color: "#40566D", fontSize: 14, fontWeight: 500 }}>
                        {label}
                    </Text>
                    {isVerified !== undefined &&
                        (isVerified ? (
                            <img src={VerifiedIcon} alt="Verified" />
                        ) : (
                            <div className="not-verified-tag">Not Verified</div>
                        ))}
                </Flex>
            </Col>

            <Col xs={24} lg={12}>
                <Flex align="center" gap={10} wrap>
                    {downloadBtn ? (
                        <CustomButton
                            type="text"
                            style={{ padding: 0, color: "#294DD8" }}
                            onClick={handleSlaDownload}
                        >
                            Download
                        </CustomButton>
                    ) : (
                        <Text copyable={copyable} style={{ color: "#101924", fontSize: 14, fontWeight: 500 }}>
                            {value}
                        </Text>
                    )}

                    {isMasked && (
                        <img
                            src={showValue ? EyeSlashIcon : EyeIcon}
                            alt="Toggle Visibility"
                            onClick={() => setShowValue(!showValue)}
                            style={{ cursor: "pointer" }}
                        />
                    )}
                </Flex>
            </Col>

            <Col xs={24} lg={6} style={{ textAlign: "right" }}>
                {isEditable && (
                    <Text className="edit-btn" onClick={onEdit}>
                        Edit
                    </Text>
                )}
            </Col>
        </Row>
    );
};

export default ProfileDetail;
